import { T } from 'react-translator-component';
interface SelectProps {
  value: string;
  label: string;
  id: string;
}

export const parserStationsForSelect = (stations: any[]): SelectProps[] | any => {
  const allStations = { value: '', id: 'BVGHIHJKBHVHJJB*&ˆ', label: T('All Stations') };

  return (
    stations && [
      allStations,
      ...stations.map((station) => ({
        value: station.chargeBoxPk,
        label: station.description || station.chargeBoxId || 'Estação sem nome',
        id: station.chargeBoxPk + station.description || station.chargeBoxId,
      })),
    ]
  );
};

export const parseUsersForSelect = (users: any[]): SelectProps[] | any => {
  const allUsersOption = { value: '', id: 'klnjhgcf&ˆ%$ˆ&', label: T('All Users') };

  return (
    users && [
      allUsersOption,
      ...users.map((user) => ({
        value: user?.user_pk,
        label: user?.user_name || 'Sem nome',
        id: Math.random() * 3,
      })),
    ]
  );
};

export const parseOcppTagsForSelect = (ocppTags: any[]): SelectProps[] | any => {
  const allOcppTagsOption = { value: '', id: 'asdegsfg&ˆˆ&%$', label: T('All Tags') };

  return (
    ocppTags && [
      allOcppTagsOption,
      ...ocppTags.map((tag) => ({
        value: tag?.idTag,
        label:
          tag?.type == 'CARD'
            ? tag?.idTag
            : tag?.userEmail != null && tag?.userEmail.length != 0 && tag?.userEmail.trim()
            ? tag?.userEmail
            : tag?.idTag,
        id: Math.random() * 3,
      })),
    ]
  );
};
